import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@/shared/ui';

import { transformCamelCaseToSpaces } from '@/shared/lib/format/transformCamelCaseToSpaces';
import FilterOptionRow from '../FilterOptionRow';

import type { FilterOption } from '../useTableFilters';

const accordionSx = { width: '100%', backgroundColor: 'transparent', p: 0 };

const summarySx = {
  borderBottom: '1px solid',
  borderBottomColor: 'gx.response',
  backgroundColor: 'gx.tileDark',
  color: 'gx.subtext',
  py: 1,
  px: 1.5,
  minHeight: 0,
  '&.Mui-expanded': { minHeight: 0 },
  '& .MuiAccordionSummary-content': { m: 0 },
  '& .MuiAccordionSummary-content.Mui-expanded': { m: 0 }
};

const detailsSx = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'gx.mainBackground',
  px: 1.5,
  py: 0.5
};

interface FilterGroupProps {
  column: string;
  options: FilterOption[];
  selected: string | null | undefined;
  onSelect: (label: string) => void;
}

const FilterGroup = ({ column, options, selected, onSelect }: FilterGroupProps) => (
  <Accordion
    defaultExpanded
    sx={accordionSx}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon sx={{ fontSize: 14 }} />}
      sx={summarySx}
    >
      {transformCamelCaseToSpaces(column)}
    </AccordionSummary>
    <AccordionDetails sx={detailsSx}>
      {options.map(({ label, count }) => (
        <FilterOptionRow
          key={label}
          checked={selected === label}
          count={count}
          label={label}
          onChange={() => onSelect(label)}
        />
      ))}
    </AccordionDetails>
  </Accordion>
);

export default FilterGroup;
